var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-grid kt-grid--ver kt-grid--root"},[_c('div',{staticClass:"kt-grid__item kt-grid__item--fluid kt-grid kt-error-v4",style:({
      backgroundImage: `url(${_vm.backgroundImage})`
    })},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-error_container"},[_c('h1',{staticClass:"kt-error_number"},[_vm._v(" 404 ")]),_c('p',{staticClass:"kt-error_title"},[_vm._v(" ERROR ")]),_c('p',{staticClass:"kt-error_description"},[_vm._v(" Nothing left to do here. ")])])
}]

export { render, staticRenderFns }